import React, { Component } from "react";

import ControlPointIcon from "@mui/icons-material/ControlPoint";
import Input from "./../../../shared/items/contols/input";

import styles from "./createRoutePanel.module.scss";
import { withRoutes } from "../../../shared/containers/containerRoutes";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import InputMask from "react-input-mask";
import has from "lodash/has";
import ValidateErrorMessage from "../../../shared/items/static/validateErrorMessage";

class CreateRoutePanel extends Component {
  constructor(props) {
    super(props);

    this.state = { value: "" };
  }

  handleChangeStore(e) {
    this.setState({ value: e.target.value });
  }

  createHandling(e) {
    const { onCreateRoute } = this.props;
    const { value } = this.state;

    onCreateRoute({ title: value, controlPoints: [], dayOffTrips: [], workDayTrips: [] });
    this.setState({ value: "" });
  }

  handleBlur() {
    const defaultValue = this.props.default;
    const { value } = this.state;

    if (!!defaultValue && value.length === 0) {
      this.setState({ value: defaultValue });
      this.handleChangeStore(this.props.name, defaultValue);
    }
  }

  render() {
    const { value } = this.state;
    const { type, id, name, disabled, errors, placeholder } = this.props;

    const isError = has(errors, name) ? "error" : "";
    const styleName = isError ? "inputStyle_error" : !!this.props.class ? `inputStyle_${this.props.class}` : "inputStyle";

    return (
      <div className={styles.createRoutePanel}>
        <div className={styles[styleName]}>
          <InputMask
            type={!!type ? type : "text"}
            id={!!id ? id : name}
            name={name}
            placeholder={!!placeholder ? placeholder : null}
            disabled={!!disabled ? true : false}
            onBlur={this.handleBlur.bind(this)}
            onChange={this.handleChangeStore.bind(this)}
            value={value}
          />
          {!!errors ? (
            <div className={styles.container_validateMessage}>
              <ValidateErrorMessage title={errors[name]} />
            </div>
          ) : null}

          <div className={styles.container_createRouteBtn}>
            <TooltipWrapper title={"Создать новый Маршрут"} position="left">
              <ControlPointIcon className={styles.icon} fontSize="large" onClick={this.createHandling.bind(this)} />
            </TooltipWrapper>
          </div>
        </div>
      </div>
    );
  }
}

export default withRoutes(React.memo(CreateRoutePanel));
